export const getRsFromCoins = (coins: number) => {
  return Math.floor(coins * 0.1);
};
